<template>
  <div class="wraps">
    <List @load="getList" v-model="loading" :finished="!hasMore" :finished-text="$t('Hint.notMore')"
      :loading-text="$t('Hint.loading')">
      <div v-for="(item, index) in lists" :key="`item_${index}`" class="item_wrap">
        <div class="_item">
          <div class="label">{{ $t('type') }}</div>
          <div class="value">{{ item.typeCn }}</div>
        </div>
        <div class="_item">
          <div class="label">{{ $t('下注期号') }}</div>
          <div class="value">{{ item.expect }}</div>
        </div>
        <div class="_item" v-if="item.status == '待开奖'">
          <div class="label">{{ $t('状态') }}:</div>
          <div class="value">{{ $t('待开奖') }}</div>
        </div>
        <div class="_item">
          <div class="label">{{ $t('下注') }}</div>
          <div class="value" :class="getStatus(item).color" v-if="!getStatus(item).type">{{ getStatus(item).text }}
          </div>
          <div class="value" v-else>
            <template v-for="(val, num) in (getStatus(item).text)">
              <img class="img" :src="require(`../../../../assets/new/game/qq_${val}.png`)" :key="num">
            </template>
          </div>
        </div>
        <div class="_item" v-if="item.status == '已开奖'">
          <div class="label">{{ $t('open.result') }}</div>
          <div class="right">
            <template v-if="Array.isArray(getResult(item))">
              <div class="value" :class="key.color" v-for="key, num in getResult(item)" :key="num">
                {{ key.text }}
              </div>
            </template>
            <template v-else>
              <div class="value" :class="getResult(item).color" v-if="!getResult(item).type">{{
                getResult(item).text }}</div>
              <div class="value" v-else>
                <img class="img" :src="require(`../../../../assets/new/game/qq_${getResult(item).text}.png`)" >
              </div>
            </template>
          </div>
        </div>
        <div class="_item">
          <div class="label">{{ $t('下注金额') }}</div>
          <div class="value">{{ $money(item.money) }}</div>
        </div>
        <div class="_item">
          <div class="label">{{ $t('中奖') }}</div>
          <div class="value">{{ $money(item.winMoney) }}</div>
        </div>
        <div class="time">{{ $format(item.indate) }}</div>
      </div>
    </List>
  </div>
</template>

<script>
import { List } from "vant";
import { post } from "@/utils/newRequest";
export default {
  components: { List },
  props: {
    type: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      page: 0,
      loading: false,
      hasMore: true,
      lists: [],
    };
  },
  methods: {
    getStatus(item) {
      let { code, method } = item;
      if (code == "0") { code = (code - 0).toString() }
      return this.getCode(code);
    },
    getCode(code) {
      switch (code) {
        case '紫':
          return { text: this.$t('紫'), color: 'item_violet' }
          break;
        case '红':
          return { text: this.$t('红'), color: 'item_red' }
          break;
        case '绿':
          return { text: this.$t('绿'), color: 'item_green' }
          break;
        case '大':
          return { text: this.$t('大'), color: 'item_big' }
          break;
        case '小':
          return { text: this.$t('小'), color: 'item_small' }
          break;
        default:
          code = code.toString();
          let result = [];
          for (let i = 0; i < code.length; i++) {
            result.push(parseInt(code[i]));
          }
          return { type: 'image', text: result }
          break;
      }
    },
    getResult(item) {
      let { method, open } = item;
      if (method == 'hl-sb' || method == 'hl-sb-z') { method = 'hl-sb' }
      let obj = open && open[method];
      let newObj = []
      if (method == 'hl-sb') {
        if (obj.length) {
          for (let i = 0; i < obj.length; i++) {
            newObj.push(this.getCode(obj[i]))
          }
          return newObj
        }
      } else if (method == 'hl-dwd') {
        newObj = this.getCode(open['hl-dwd'])
        return newObj
      } else if (method == 'dxds') {
        newObj = this.getCode(open && open['dxds'][0].dx)
        return newObj
      }
    },
    async getList(lower = false) {
      if (!lower) {
        this.page++;
      }
      try {
        const { lists, hasMorePages } = await post("/lottery/order", {
          type: this.type,
          pagesize: 20,
          page: this.page,
        });
        const realList = lists
        this.hasMore = hasMorePages;
        if(lower){
          this.lists = [...realList]
        }else{
          this.lists = [...this.lists, ...realList];
        }
        this.loading = false;
      } catch (error) {
        this.loading = false;
        this.page--;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.wraps {
  padding: 0 calc(10rem / 16);

  .item_wrap {
    background: var(--btn_bg);
    border-radius: calc(20rem / 16);
    padding: calc(15rem / 16);
    margin-top: calc(15rem / 16);
    color: var(--light);
    display: flex;
    flex-direction: column;
    gap: calc(5rem / 16);
    ._item {
      display: flex;
      justify-content: space-between;
      line-height: 2;
      gap: calc(15rem / 16);

      .label {
        font-size: calc(14rem / 16);
      }

      .right {
        display: flex;
        column-gap: calc(20rem / 16);
        justify-content: flex-end;
        flex: 1;
      }

      .value {
        font-size: calc(14rem / 16);
        max-width: 60%;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        gap: calc(5rem / 16);
        justify-content: space-between;

        .img {
          width: calc(30rem / 16);
          height: calc(30rem / 16);
          display: block;
        }
      }
    }

    .time {
      color: rgba(255, 255, 255, .8);
      font-size: calc(13rem / 16);
      line-height: 2;
    }
  }

  .item_green {
    color: #95E27A !important;
  }

  .item_violet {
    color: #C969E1 !important;
  }

  .item_red {
    color: #FD3434 !important;
  }

  .item_big {
    color: #F9DB76 !important;
  }

  .item_small {
    color: #6FDE49 !important;
  }
}
</style>